<template>
  <div id="prepare-login">
    <img src="@/assets/loading.gif" alt="loading">
  </div>
</template>

<script>
export default {
  data () {
    return {
      appList: [
        'inventory://login',
        'inventory-dev://login',
        'inventory-staging://login',
        'gwstore://login',
      ]
    }
  },
  mounted () {
    const query = this.$route.query
    if (query.callback_uri) {
      let uri = `${query.callback_uri}${this.$route.hash}`
      if (this.appList.includes(query.callback_uri)) {
        uri = query.callback_uri
      }
      window.localStorage.setItem('callback_uri', uri)
      if (this.$auth.isAuthenticated()) {
        this.$router.push({ name: 'selectStore' })
      }
    }
  }
}
</script>
<style lang="css" scoped>
  #prepare-login {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }
</style>
